import axios from 'axios';

import { getSchedulingServerURL } from '../../HarverPages/shared/helper';

export async function makeCandidateUnavailable(calendarEventId: string, message: string, reason: string) {
    return axios.post(`${getSchedulingServerURL()}/interview/unavailable`, {
        calendarEventId,
        message,
        reason,
    });
}

export interface InterviewDetails {
    organizationName: string;
    status: string;
}
export async function getInterviewDetails(calendarEventId: string): Promise<InterviewDetails> {
    const apiEndpoint = `${getSchedulingServerURL()}/interview/details?ref=${calendarEventId}`;
    const { data } = await axios.get(apiEndpoint);

    return data;
}
